<template>
	<div class="page home">
		<div class="logo">
			<img src="../assets/logo.png" />
		</div>
		<h1>
			Je réalise
			<br />mon étude budgétaire
		</h1>
		<div>
			<img src="../assets/separation.png" />
		</div>
		<router-link to="/terrain/" class="button">C'est parti</router-link>
		<div>
			<img src="../assets/separation.png" />
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import { Plugins } from "@capacitor/core";
	const { Storage } = Plugins;

	export default {
		name: "Accueil",
		components: {},
		data() {
			return {
				user: ""
			};
		},
		methods: {
			async getUser() {
				this.user = await Storage.get({ key: "user" });
			}
		},
		mounted() {
			this.$store.commit("resetState");
			this.$store.commit("setTimer", 60);
			Storage.set({
				key: "user",
				value: "Prénom"
			});
			this.getUser();
		}
	};
</script>

<style lang="less">
	.home {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		text-align: center;
		flex-direction: column;
		padding-top: 40px;
		.logo {
			margin-bottom: 50px;
		}
		h1 {
			font-size: 50px;
			text-transform: uppercase;
			line-height: 60px;
			font-weight: 100;
			color: white;
			margin: 0 0 50px 0;
		}
	}
</style>
